import React, { useState, useEffect } from "react";
import classes from "./cutoffcalendarsearch.module.scss";
import { FormControl, TextField, Button, Grid,Box, InputLabel, MenuItem, Select } from "@mui/material";
import { Icon, DatePicker } from "@genesis/ui-kit";
import axios from "axios";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import { useNavigate, NavLink, useLocation } from "react-router-dom";
import { CheckIsUserAdmin,} from "../../../../Shared/Utill/Utills";
import SnackBar from "../../../../Shared/Snackbar/Snackbar";
import DivisionDropDownComp from "../../DivisionDropdown/DivisionDropdownComp";
import EditIcon from '@mui/icons-material/Edit';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { constants } from "../../../../Shared/Url/Constants";
import moment from 'moment';

import {
  useGridApiRef,
  DataGridPro,
  GridToolbarContainer,
  GridActionsCellItem
} from "@mui/x-data-grid-pro";

import { isString } from "../../../../Shared/Utill/Utills"
import axiosInstance from "../../../../Shared/Utill/AxiosConfig";

const CutOffCalendarSearch = () => {
  const personDetails = useSelector(
    (state) => state.personStatic.personStaticData
  );
  const urlDetails = useSelector((state) => state.url.urlData);
  const token = Cookies.get("X_TKN");
  const history = useNavigate();
  const [divSelectedValue, setDivSelectedValue] = useState(null);
  const [fiscalWeek, setfiscalWeek] = useState(null);

  const [isAlertOpen, setAlertOpen] = React.useState({});
  const { message, severity, open } = isAlertOpen || {};
  const location = useLocation();
  const [searchValue, setSearchValue] = useState([]);
  const [searchValueApi, setSearchValueApi] = useState([]);
  const [yearList,setYearList] = useState(false);
  const [yearSelectedValue, setYearSelectedValue] = useState(null);
  
  // check user role at page
  CheckIsUserAdmin();

  useEffect(() => {
    let isDeleteSuccess = location.state !== null ? true : false;
    if(isDeleteSuccess){
      setAlertOpen({
        open: true,
        severity:  'success',
        message : location.state.message,
      })
    }
    getAllYearList();
  },[]);


  const getAllYearList = () => {
    axios({
      url: `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_CALENDAR_GET_FSC_YEARS}`,
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Authorization':'Bearer ' + token,
      },
    }).then((res) => {
      setYearList(res.data);
    }).catch((err) => {
      if(err.message === 'Network Error') {
        history("/somethingwentwrong", {state:`Please logout and try again `})
      }else {
        history("/somethingwentwrong", {state:`${constants.WFM_CALENDAR_GET_FSC_YEARS}...failed`})
        }
    });

  }

  const onDivDropDownSelect = (selectedDivision) => {
    setDivSelectedValue(selectedDivision);
  };

  const onYearListSelect = (selectedYear) => {
    setYearSelectedValue(selectedYear);
  };


  const handleAlertNotifClose = () => {
    setAlertOpen({});
  };

  const [count, setCount] = React.useState(0);

  const apiRef = useGridApiRef();

  const handleRowEditStart = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleRowEditStop = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleEditClick = (id) => (event) => {
    
    event.stopPropagation();
    apiRef.current.startRowEditMode({ id });
    
  };

  const handleSaveClick = (id) => async (event) => {
    event.stopPropagation();
    await apiRef.current.stopRowEditMode({ id });
  };

  const handleCancelClick = (id) => async (event) => {
    event.stopPropagation();
    await apiRef.current.stopRowEditMode({ id, ignoreModifications: true });

    const row = apiRef.current.getRow(id);
    if (row.isNew) {
      apiRef.current.updateRows([{ id, _action: "delete" }]);
    }
  };

  const columns = [
    { field: 'division', headerName: 'Division', width: "130" },
    { field: 'fiscalyear', headerName: 'Fiscal Year', width: "100" },
    { field: 'fiscalweek', headerName: 'Fiscal Week', width: "100" },
    { field: 'weekstart', headerName: 'Week Start', width: "150", renderCell: (params) => {
      if(params.row.weekstart !== null) {
       return moment(params.row.weekstart).format('MMM DD, YYYY');
      }  else {
       return params.row.weekstart;
      }   
   } },
    { field: 'weekend', headerName: 'Week End', width: "150", renderCell: (params) => {
      if(params.row.weekend !== null) {
       return moment(params.row.weekend).format('MMM DD, YYYY');
      }  else {
       return params.row.weekend;
      }   
   } },
    { field: 'colleaguedeadline', headerName: 'Colleague Deadline', width: "150", type: 'date', editable: true, renderCell: (params) => {
      if(params.row.colleaguedeadline !== null) {
       return moment(params.row.colleaguedeadline).format('MMM DD, YYYY');
      }  else {
       return params.row.colleaguedeadline;
      }   
   } },
    { field: 'divisionalcutoff', headerName: 'Divisional Cutoff', width: "150", editable: true, type: 'singleSelect',valueOptions: [
      { value: 'Y', label: 'Yes' },
      { value: 'N', label: 'No' }
    ], renderCell: (params) => {
       if(params.row.divisionalcutoff === 'Y') {
        return "Yes"
       } else if(params.row.divisionalcutoff === 'N') {
        return ""
       } else {
        return params.row.divisionalcutoff;
       }   
    } },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 180,
      getActions: ({ id }) => {
        const isInEditMode = apiRef.current.getRowMode(id) === "edit";

        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveOutlinedIcon />}
              label="Save"
              onClick={handleSaveClick(id)}
              color="inherit"
            />,
            <GridActionsCellItem
              icon={<CloseIcon />}
              label="Cancel"
              className="textPrimary"
              onClick={handleCancelClick(id)}
              color="inherit"
            />
          ];
        }

        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(id)}
            color="inherit"
          />,
          
        ];
      }
    }
    
    ];

    const processRowUpdate = async (newRow) => {
      console.log("processRowUpdate");
  
      console.log("new row", newRow)
      let div = (newRow.division).split("-");
      div = div[0];

      let colleaguedeadline = null;
      if(newRow.colleaguedeadline !== null){
        colleaguedeadline = moment(newRow.colleaguedeadline).format('YYYY-MM-DD')
      }

      let result = searchValueApi.filter(week => week.fscWw === newRow.id);
      console.log("result", result)

      let addData = {
        fscCalDate: newRow.weekstart,
        divNbr: div,
        weeklyDeadline: colleaguedeadline,
        divisionalCutoff: newRow.divisionalcutoff === "Y" ? "Y" : "N",
        lastUpdatedBy:personDetails.emplID,
      } 

      
      let editData = {
        accId: result[0].accId,
        fscCalDate: newRow.weekstart,
        divNbr: div,
        weeklyDeadline: colleaguedeadline,
        divisionalCutoff: newRow.divisionalcutoff,
        lastUpdatedBy:personDetails.emplID,
      } 

      let futureChk = true;
      if(newRow.colleaguedeadline !== null && moment(newRow.colleaguedeadline).isBefore(moment(), "day")){
        futureChk = false;
      }

      if(newRow.colleaguedeadline !== null && moment(newRow.colleaguedeadline).format('dddd') !== "Saturday") {
        setAlertOpen({
          open: true,
          severity: 'error',
          message: "Please select Saturday date only for colleague deadline.",
      });
      return;
      } else if(!futureChk){
        setAlertOpen({
          open: true,
          severity: 'error',
          message: "Please select any future Saturday date.",
      });
      return;

      } else {

      if(result && result[0].accId !== null) {
      axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVLL_CUT_OFF_CALENDAR_EDIT}`, 
      editData,
      {
       headers:{
       'Content-Type': 'application/json',
       'Authorization':'Bearer ' + token,
       }
      }).then((res) => {

        setAlertOpen({
          open: true,
          severity: 'success',
          message: 'Record updated successfully',
      });
      // call search
      handleSearch()
       
      }).catch((err) => {
        setAlertOpen({
          open: true,
          severity: 'error',
          message: err.response.data.message,
      });
      handleSearch()
      }); 
    } else {

      axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVLL_CUT_OFF_CALENDAR_ADD}`, 
      addData,
      {
       headers:{
       'Content-Type': 'application/json',
       'Authorization':'Bearer ' + token,
       }
      }).then((res) => {

        setAlertOpen({
          open: true,
          severity: 'success',
          message: 'Record added successfully',
      });
      // call search
      handleSearch()
       
      }).catch((err) => {
        setAlertOpen({
          open: true,
          severity: 'error',
          message: err.response.data.message,
      });
      handleSearch()
      }); 

    } // add call
    } // valid saturday date 
      
  
      return { ...newRow, isNew: false };
    };
  
    const handleError = (err) => {
      console.log("handleError");
  
      console.log(err);
      setTimeout(() => {
        setCount((o) => o + 1);
      }, 1000);
    };

  //------
  const handleSearch = () => {
    if(divSelectedValue == null){
      setAlertOpen({
        open: true,
        severity: 'error',
        message: 'Please select Division',
    });
    return;
    }
    if(yearSelectedValue == null){
      setAlertOpen({
        open: true,
        severity: 'error',
        message: 'Please select Fiscal Year',
    });
    return;
    }

    if (isString(fiscalWeek)) {

      setAlertOpen({
        open: true,
        severity: "error",
        message: "Fiscal Week should be numeric.",
      });
      return;
    }
    
   
 // data for searching
 let data = {
  displayDiv: divSelectedValue.divNbr + "-" + divSelectedValue.divName,
  divNbr: divSelectedValue.divNbr,
  fscYyyy: yearSelectedValue,
  fscWw: fiscalWeek
} 

axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVLL_CUT_OFF_CALENDAR_SEARCH}`, 
data,
{
 headers:{
 'Content-Type': 'application/json',
 'Authorization':'Bearer ' + token,
 }
}).then((res) => {
 
 let tmparr = []
 console.log("response",res.data);
 setSearchValueApi(res.data)
 res.data.map(obj => {
    let tmpobj = {}
    tmpobj.id = obj.fscWw;
    tmpobj.division = obj.displayDiv;
    tmpobj.fiscalyear = obj.fscYyyy;    
    tmpobj.fiscalweek = obj.fscWw;
    tmpobj.weekstart = obj.fscWeekStart;
    tmpobj.weekend = obj.fscWeekEnd;
    tmpobj.colleaguedeadline = obj.weeklyDeadline;
    tmpobj.divisionalcutoff = obj.divisionalCutoff;
    tmparr.push(tmpobj);
   
 });
 setSearchValue(tmparr);
 
}).catch((err) => {
 if(err.message === 'Network Error') {
   history("/somethingwentwrong", {state:`Please logout and try again `})
 }else {
   history("/somethingwentwrong", {state:`${constants.WFM_AVLL_CUT_OFF_CALENDAR_SEARCH}...failed`})
   }
}); 

  };

  return (
    <div className={classes.pagemargin}>
      <div className={classes.pagetitle}>Cutoff Calendar</div>
      <div className={classes.icon_text_wrap}>
        <div className={classes.icon_text}>
          
        </div>
      </div>

      <div className={classes.searchbox}>
        <SnackBar
          open={open}
          message={message}
          severity={severity}
          onClose={handleAlertNotifClose}
        ></SnackBar>

        <Grid container spacing={3}>
          <Grid key={0} item xs={2}>
            <DivisionDropDownComp
              onDivChange={(e) => onDivDropDownSelect(e)}
              mandatory="*"
            ></DivisionDropDownComp>
          </Grid>
          <Grid key={1} item xs={2}>
            <FormControl sx={{ minWidth: '100%'}}>
              <InputLabel id="demo-select-basic-label">Fiscal Year * </InputLabel>
              <Select
              labelId="demo-select-basic-label"
              id="demo-select-basic"
              label="Dropdown Label"
              value={yearSelectedValue || ''}
              onChange={(e) => setYearSelectedValue(e.target.value)}
              >
              {yearList && yearList.map((e) =>
                <MenuItem key={e} value={e}>{e}</MenuItem>
              )}
              </Select>
             </FormControl>
          </Grid>
          
          <Grid key={2} item xs={2}>
            <FormControl style={{ minWidth: "100%" }}>
              <TextField
                label="Fiscal Week (Opt)"
                onChange={(e) => setfiscalWeek(e.target.value)}
                value={fiscalWeek}
              />
            </FormControl>
          </Grid>
          <Grid key={3} item xs={2}>
            <Button
              style={{
                marginLeft: "10px",
                paddingTop: "14px",
                paddingBottom: "14px",
                paddingLeft: "80px",
                paddingRight: "80px",
                marginRight: "5px",
              }}
              onClick={handleSearch}
            >
              Search
            </Button>
          </Grid>
        </Grid>
      </div>
      <div style={{marginTop:"30px"}}>
        <div style={{fontSize:"18px", fontWeight:"bold", marginLeft:"5px", marginBottom:"5px"}}>{searchValue.length} Results Found</div>
    <Box sx={{ height:  400, width: "90%" }} >
    <SnackBar
        open={open}
        message={message}
        severity={severity}
        onClose={handleAlertNotifClose}
        ></SnackBar>
    <DataGridPro
          rows={searchValue}
          columns={columns}
          apiRef={apiRef}
          editMode="row"
          onRowEditStart={handleRowEditStart}
          onRowEditStop={handleRowEditStop}
          processRowUpdate={processRowUpdate}
          onProcessRowUpdateError={handleError}
          
          componentsProps={{
            toolbar: { apiRef }
          }}
          experimentalFeatures={{ newEditingApi: true }}
        />
    </Box></div>
      
    </div>
  );
};

export default CutOffCalendarSearch;

